// ============================================================
//  Conexion al backendCotizaciones
//  - En local (localhost/127.0.0.1) usa el backend local.
//  - En cualquier otro caso usa la URL de produccion.
//  Se puede sobreescribir con la variable REACT_APP_API_URL.
// ============================================================

const esLocal =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");

// Backend local (npm start del proyecto backendCotizaciones).
const URL_LOCAL = "http://localhost:3001";

// URL de produccion del backend. Cambia este valor por el real cuando se
// despliegue (o define REACT_APP_API_URL en el entorno de build).
const URL_PRODUCCION =
    process.env.REACT_APP_API_URL || "https://backendcotizaciones-854449656601.us-central1.run.app";

export const API_URL = esLocal ? URL_LOCAL : URL_PRODUCCION;

// Base de los endpoints de cotizaciones.
export const API_BASE = `${API_URL}/api/cotizaciones/v1`;

// Numero de la mesa de ayuda (S360) que se muestra al cliente cuando la
// cotizacion esta cerrada o no se pudo generar.
export const SOPORTE_WHATSAPP = "+573244071621";
export const SOPORTE_WHATSAPP_DISPLAY = "324 407 1621";
